import React from 'react'

const MilestoneIcon = ({ x, y }) => (
  <svg
    x={x}
    y={y}
    width='17px'
    height='18px'
    viewBox='0 0 17 18'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <defs>
      <path
        d='M6.88095238,0 L0.404761905,0 C0.181171429,0 0,0.167235157 0,0.373626356 L0,6.35164806 C0,6.45491838 0.0454952381,6.54847442 0.118838095,6.61617552 L3.35660952,9.60488747 C3.37522857,9.62192483 3.39546667,9.63716879 3.41732381,9.65076879 C3.4273619,9.65704571 3.43853333,9.66137977 3.44905714,9.66675999 C3.46152381,9.67318637 3.47350476,9.68006109 3.48661905,9.68529186 C3.50005714,9.69052263 3.51446667,9.69336219 3.52839048,9.6972479 C3.53972381,9.70038637 3.55073333,9.70472043 3.56239048,9.70681274 C3.58878095,9.71159516 3.61565714,9.71428571 3.64285714,9.71428571 C3.74615238,9.71443472 3.84475238,9.67722153 3.91971429,9.61191164 C3.92262857,9.60937098 3.92619048,9.60757758 3.92910476,9.60488747 L7.16687619,6.61617552 C7.24021905,6.54847442 7.28571429,6.45491838 7.28571429,6.35164806 L7.28571429,0.373626356 C7.28571429,0.167235157 7.10454286,0 6.88095238,0'
        id='path-1'
      ></path>
    </defs>
    <g id='R3-Web-App' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='R3-WebApp---Progress-(Filtered)-MILESTONE-BASED' transform={`translate(-596.000000, -628.000000)`}>
        <g
          id='Group-8'
          transform='translate(604.500000, 637.500000) rotate(-360.000000) translate(-604.500000, -637.500000) translate(596.000000, 629.000000)'
        >
          <g id='Icon/Milestone-Copy' transform='translate(8.500000, 8.500000) rotate(-360.000000) translate(-8.500000, -8.500000) '>
            <g id='Milestone' transform='translate(4.857143, 3.642857)'>
              <mask id='mask-2' fill='white'>
                <use xlinkHref='#path-1' />
              </mask>
              <use id='Mask' fill='#000000' xlinkHref='#path-1' />
              <g id='Color' mask='url(#mask-2)' fill='#F7901E'>
                <g transform='translate(-4.857143, -3.642857)'>
                  <rect x='0' y='0' width='17' height='17'></rect>
                </g>
              </g>
            </g>
          </g>
          <path
            d='M10.5048069,4.68750015 C10.5897338,4.68750015 10.6688162,4.71378739 10.7350831,4.75903894 C10.7381769,4.76258878 10.7426209,4.7656458 10.7470211,4.76879984 C10.7641676,4.78019197 10.7792339,4.79306298 10.7933923,4.8069429 C10.7963495,4.81008843 10.8001699,4.81385224 10.8039392,4.8177046 L14.1885543,8.37326015 L14.2411885,8.44061111 C14.256367,8.46446905 14.2693499,8.48986811 14.2799145,8.51645857 C14.3014481,8.57080271 14.3125664,8.62855059 14.3124995,8.68750015 C14.3124995,8.74741434 14.3010437,8.80536083 14.2799145,8.85854174 L14.2414669,8.93409926 C14.2261114,8.95825066 14.2084224,8.98092803 14.1885543,9.00174015 L10.8039392,12.5572957 L10.7933923,12.5680574 C10.7792339,12.5819373 10.7641676,12.5948083 10.7482973,12.6065614 L10.8039392,12.5572957 C10.7820872,12.5796289 10.7585189,12.5989865 10.7336918,12.6153715 C10.6688162,12.6612129 10.5897338,12.6875002 10.5048069,12.6875002 L3.73557674,12.6875002 C3.50191782,12.6875002 3.31249985,12.4885156 3.31249985,12.2430557 L3.31249985,5.1319446 C3.31249985,4.88648471 3.50191782,4.68750015 3.73557674,4.68750015 L10.5048069,4.68750015 Z M13.2904998,8.68650015 L10.3294998,5.57550015 L4.15849985,5.57550015 L4.15849985,11.7985002 L10.3294998,11.7985002 L13.2904998,8.68650015 Z'
            id='Combined-Shape'
            fill='#000000'
            fillRule='nonzero'
            transform='translate(8.812500, 8.687500) rotate(-270.000000) translate(-8.812500, -8.687500) '
          />
        </g>
      </g>
    </g>
  </svg>
)

export default MilestoneIcon
